<template>
    <section :id="`element-${settings.id}`" class="elle-intro padd-v" :style="{ backgroundColor: settings?.color }">
        <div class="container">
            <div class="grid12">
                <div class="m-col">
                    <UiHeadline
                        :style="'center'"
                        :settings="{
                            label: settings?.label,
                            headline: settings?.headline
                        }"
                    >
                        <template #additional>
                            <div v-if="settings?.body" class="content typography" v-html="props.settings?.body" />
                            <div v-if="settings?.linkUrl.length" class="buttons">
                                <UiLink :link="settings?.linkUrl[0]" :style="'transparent w-border'" />
                            </div>
                        </template>
                    </UiHeadline>

                    <UiMediaWithVideo :media="settings?.media" :video="settings?.video" wrapper-class="single-media" />
                </div>
            </div>

            <ClientOnly>
                <div v-if="settings?.gallery.length" class="elle-intro-gallery">
                    <div v-if="isDesktop" class="grid12">
                        <div v-for="item in settings?.gallery" :key="item.id" class="page-media">
                            <UiImage :src="item.webp" />
                        </div>
                    </div>

                    <UiSliderMobile v-else>
                        <template #sliders>
                            <swiper-slide v-for="item in settings?.gallery" :key="item.id" class="swiper-slide">
                                <div class="page-media w-ratio">
                                    <UiImage :src="item.webp" :classes="'responsive'" />
                                </div>
                            </swiper-slide>
                        </template>
                    </UiSliderMobile>
                </div>
            </ClientOnly>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});

const isDesktop = useMediaQuery('(min-width: 768px)');
</script>
